// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArrowLinkButton_button__Lglem {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: calc(var(--space-xs) * 0.75) var(--space-sm);
  border: 1px solid transparent;
  border-radius: 25px;
  background: transparent;
  color: var(--color-text);
  font-size: var(--font-size-small);
  cursor: pointer;
  transition: border-color 0.3s ease, background-color 0.3s ease,
    color 0.3s ease;
}

.ArrowLinkButton_button__Lglem:hover {
  border-color: rgba(77, 163, 255, 0.65);
  background: rgba(77, 163, 255, 0.08);
}

.ArrowLinkButton_arrow__s0iXp {
  color: #4da3ff;
  font-size: 1.1em;
}
`, "",{"version":3,"sources":["webpack://./src/components/ArrowLinkButton.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;EACrD,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,eAAe;EACf;mBACiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: calc(var(--space-xs) * 0.75) var(--space-sm);\n  border: 1px solid transparent;\n  border-radius: 25px;\n  background: transparent;\n  color: var(--color-text);\n  font-size: var(--font-size-small);\n  cursor: pointer;\n  transition: border-color 0.3s ease, background-color 0.3s ease,\n    color 0.3s ease;\n}\n\n.button:hover {\n  border-color: rgba(77, 163, 255, 0.65);\n  background: rgba(77, 163, 255, 0.08);\n}\n\n.arrow {\n  color: #4da3ff;\n  font-size: 1.1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `ArrowLinkButton_button__Lglem`,
	"arrow": `ArrowLinkButton_arrow__s0iXp`
};
export default ___CSS_LOADER_EXPORT___;
